import React from "react";
import "./UserTable.css";

export default function UserTable({ users, onDelete, onAdd, onResetPassword }) {
  const h = React.createElement;
  const [temps, setTemps] = React.useState({});
  const [loading, setLoading] = React.useState({});

  async function handleReset(u) {

    if (u.role === "admin") {
      alert("You cannot reset the password for an admin user.");
      return;
    }

    setLoading((m) => ({ ...m, [u.id]: true }));
    try {
      const tempPwd = await onResetPassword(u); // <- Comes from parent
      setTemps((t) => ({ ...t, [u.id]: tempPwd }));
    } catch (err) {
      console.error(err);
      alert("Failed to reset password");
    } finally {
      setLoading((m) => ({ ...m, [u.id]: false }));
    }
  }

  async function handleDelete(u) {
    if (u.role === "admin") {
      alert("You cannot delete an admin user.");
      return;
    }
    await onDelete(u.id)
  }

  return h(
    "div",
    { className: "users-page" },
    h(
      "div",
      { className: "users-card" },
      h(
        "div",
        { className: "users-header" },
        h("h2", null, "Users"),
        h("button", { className: "btn primary", onClick: onAdd }, "+ Add User")
      ),
      users.length === 0
        ? h("div", { style: { padding: 18, color: "#6b778c" } }, "No users yet.")
        : h(
            "table",
            { className: "users-table" },
            h(
              "thead",
              null,
              h(
                "tr",
                null,
                h("th", null, "Name"),
                h("th", null, "Email"),
                h("th", null, "Org"),
                h("th", null, "Role"),
                h("th", null, "Temp Password"),
                h("th", null, "Actions")
              )
            ),
            h(
              "tbody",
              null,
              users.map((u) =>
                h(
                  "tr",
                  { key: u.id },
                  h("td", null, u.name),
                  h("td", null, u.email),
                  h("td", null, u.org),
                  h("td", null, h("span", { className: "role-pill" }, u.role)),
                  h("td", null, temps[u.id] || "—"),
                  h(
                    "td",
                    null,
                    h(
                      "div",
                      { style: { display: "flex", gap: 8 } },
                      h(
                        "button",
                        {
                          className: "btn",
                          disabled: loading[u.id],
                          onClick: () => handleReset(u),
                        },
                        loading[u.id] ? "..." : "Reset"
                      ),
                      h(
                        "button",
                        {
                          className: "btn danger",
                          onClick: () => handleDelete(u),
                        },
                        "Delete"
                      )
                    )
                  )
                )
              )
            )
          )
    )
  );
}
